import * as yup from 'yup';

export const transformacaoBeneficioSchema = () => {
  return yup.object({
    opcaoRetiradaVista: yup.string().required('Campo obrigatório'),
    percentualRetiradaVista: yup.number().when('optionRetiradaVista', {
      is: (value) => value === 'S',
      then: (field) =>
        field
          .required('Campo é obrigatório')
          .min(1, 'Valor mínimo: 1%')
          .max(20, 'Valor máximo: 20%'),
      otherwise: (field) => field.optional(),
    }),
    percentualRendaMensal: yup
      .number()
      .required()
      .float(2, 'Máximo de duas casas decimais após o ponto')
      .min(0.1, 'Valor mínimo: 0,10%')
      .max(1, 'Valor máximo: 1,00%'),
    opcaoParcelaAdicional: yup.string().required('Campo obrigatório'),
  });
};

export const retiradaAVistaSchema = () => {
  return yup.object({
    opcaoRetiradaVista: yup.string().required('Campo obrigatório'),
    percentualRetiradaVista: yup.number().when('opcaoRetiradaVista', {
      is: (value) => value === 'S',
      then: (field) =>
        field
          .required('Campo é obrigatório')
          .min(1, 'Valor mínimo: 1%')
          .max(20, 'Valor máximo: 20%'),
      otherwise: (field) => field.optional(),
    }),
  });
};

export const percentualRendaTemporariaSchema = () => {
  return yup.object({
    percentualRendaMensal: yup
      .number()
      .required()
      .float(2, 'Máximo de duas casas decimais após o ponto')
      .min(0.1, 'Valor mínimo: 0,10%')
      .max(1, 'Valor máximo: 1,00%'),
  });
};

export const calculadoraExaurimentoSchema = (
  valorMaximoPercentual,
  visibleAporte,
  visibleParcelaAdicional
) => {
  return yup.object({
    opcaoAporte: visibleAporte
      ? yup.string().required('Campo obrigatório')
      : yup.string(),
    valorAporte: yup.number().when('opcaoAporte', {
      is: (value) => value === 'S',
      then: (field) =>
        field
          .required('Campo é obrigatório')
          .positive()
          .truncate()
          .float(2, 'Máximo de duas casas decimais após o ponto')
          .min(200, 'O valor de aporte não pode ser inferior a R$200,00'),
      otherwise: (field) => field.optional(),
    }),
    percentualRendaMensal: yup
      .number()
      .required()
      .float(2, 'Máximo de duas casas decimais após o ponto')
      .min(0.1, 'Valor mínimo: 0,10%')
      .max(valorMaximoPercentual, `Valor máximo: ${valorMaximoPercentual},00%`),
    opcaoParcelaAdicional: visibleParcelaAdicional
      ? yup.string().required('Campo obrigatório')
      : yup.string(),
  });
};

export class RetiradaAVistaModel {
  percentualSaqueVista = '';
}
